export const support = {
         title: {
           ja: "zer◯の活動はたくさんの方々に支えられています。",
           en: "Our activities are supported by many people.",
         },
         intro: {
           ja:
             "現在、多くの方々に寄付や活動場所の提供等のご支援をいただいております。\nまた、楽曲・美術・衣装など専門技術によるコラボレーションを提案してくださる方もいらっしゃいます。たくさんの人が輪に加わることで、次々に新しいアイデアや人のつながりが生まれています。\n\nホームページやSNSを通して、また、実際に公演やワークショップに足をお運びいただき、私たちのことを知ってください。そして、もしも私たちの活動に共感して頂けましたら、是非zer◯と関わってください。\n\n皆様のご参加・応援をお待ちしています。\n\nお問い合わせは以下のアドレスにて承ります。",
           en:
             "We are grateful for the support of many people who have donated money and provided us with a place to work.\nThere are also people who have proposed collaborations with us on music, art, costumes, and other specialized techniques. When many people join the circle, new ideas and connections are born one after another.\n\nWe hope you will visit our website, social networking sites, or visit our performances and workshops. If you can identify with our activities, please get involved with zer◯.\n\nWe'd love to hear from you.\n\nIf you have any questions, please contact us at the following address.",
         },
         items: [
           {
             image: "/assets/support/r2.jpg",
             link: "https://www.ebiharashoten.com/",
             title: {
               ja: "海老原商店(築90年の古民家ギャラリー）",
               en: "EBIHARA shoten (90 year old private house gallery)",
             },
             body: {
               ja: "活動場所の提供・イベント開催の支援をいただいています。",
               en:
                 "Support for providing places for activities and holding events.",
             },
           },
           {
             image: "/assets/support/r3.jpg",
             link: "http://symsym.net",
             title: {
               ja: "Sym’s BALLET",
               en: "Sym’s BALLET",
             },
             body: {
               ja: "活動場所を提供していただいています。",
               en: "Providing us with a place to work.",
             },
           },
           {
             image: "/assets/support/r4.jpg",
             link: "https://balletstudioblanckk.wixsite.com/mysite",
             title: {
               ja: "Ballet Studio Blanc",
               en: "Ballet Studio Blanc",
             },
             body: {
               ja: "活動場所を提供していただいています。",
               en: "Providing us with a place to work.",
             },
           },
           {
             image: "/assets/support/r5.jpg",
             link: "http://temae.jp",
             title: {
               ja: "temae/テマエ 青山のまちづくり拠点",
               en: "temae (The base for community development in Aoyama)",
             },
             body: {
               ja: "活動場所を提供していただいています。",
               en: "Providing us with a place to work.",
             },
           },
         ],
       };
